export const drAndCoachStaticData = {
    email: "drandcoach3@gmail.com",
    phone: "201206039648+",
    address: "محرم بك الاسكندرية",
    facebook: "https://www.facebook.com/DrandCoachTeam",
    linkedIn: "https://www.linkedin.com/in/dr-andcoach-b3139b313/",
    instagram: "https://www.instagram.com/drandcoach/",
    twitter: "https://x.com/DrAndcoach",
    youtube: "https://www.youtube.com/@doctorandcoach "
}